<template>
  <maintenance
    v-if="$store.state.marketplace.marketplaceError"
    :page-name="'Marketplace'"
    :error="$store.state.marketplace.marketplaceError"
  />
  <v-container v-else class="page" :class="isLoggedIn && 'dashboard'">
    <v-row class="mx-0 align-center">
      <h1 class="font-weight-light mt-5 mb-4">
        <!-- {{getCurrentGroup ? `${getCurrentGroup.name} Marketplace` : 'Marketplace'}} -->
        Marketplace
      </h1>
    </v-row>
    <marketplace-items :market-place-filter="!hasBrandedView" />
  </v-container>
</template>

<script>
// Utilities
import { mapGetters, mapMutations } from "vuex";

import MarketplaceItems from "../components/MarketplaceItems.vue";
import Maintenance from "./Maintenance.vue";

export default {
  metaInfo: {
    // title: 'Marketplace',
    meta: [
      { name: "description", content: "Marketplace for Services, Apps & Data Products" },
      { name: "keywords", content: "EOxHub, Marketplace" }
    ]
  },
  components: {
    MarketplaceItems,
    Maintenance
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn"]),
    ...mapGetters("config", ["hasBrandedView"]),
    ...mapGetters("marketplace", ["getCurrentGroup"])
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapMutations("marketplace", ["SET_GROUP"]),
    async init() {
      this.resetRepo();
      if (this.hasBrandedView) {
        this.SET_GROUP(this.hasBrandedView);
      }
    },
    resetRepo() {
      this.SET_GROUP();
    }
  }
};
</script>
